import { createSlice } from '@reduxjs/toolkit';
import {
	resetAppointmentNotification,
	fetchInAppUnreadCount,
	fetchInAppNotifications,
	markInAppNotificationRead,
} from './notificationActions';

const initialState = {
	loading: false,
	appointments: 0,
	messages: 0,
	wallet: 0,
	support: 0,
	error: null,
	success: false,
	inAppItems: [],
	inAppUnreadCount: 0,
	inAppTotal: 0,
	inAppLoading: false,
};

const notificationSlice = createSlice({
	name: 'notification',
	initialState,
	reducers: {
		inAppReceived: (state, action) => {
			const n = action.payload;
			if (!n?.id) return;
			if (state.inAppItems.some((x) => x.id === n.id)) return;
			state.inAppItems.unshift(n);
			if (!n.readAt) state.inAppUnreadCount += 1;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(resetAppointmentNotification.fulfilled, (state) => {
			state.appointments = 0;
		});
		builder.addCase(fetchInAppUnreadCount.fulfilled, (state, action) => {
			state.inAppUnreadCount = action.payload?.count ?? 0;
		});
		builder.addCase(fetchInAppNotifications.pending, (state) => {
			state.inAppLoading = true;
		});
		builder.addCase(fetchInAppNotifications.fulfilled, (state, action) => {
			state.inAppLoading = false;
			state.inAppItems = action.payload.items ?? [];
			state.inAppTotal = action.payload.total ?? 0;
		});
		builder.addCase(fetchInAppNotifications.rejected, (state) => {
			state.inAppLoading = false;
		});
		builder.addCase(markInAppNotificationRead.fulfilled, (state, action) => {
			const updated = action.payload;
			if (!updated?.id) return;
			const idx = state.inAppItems.findIndex((x) => x.id === updated.id);
			if (idx >= 0) state.inAppItems[idx] = updated;
		});
	},
});

export const { inAppReceived } = notificationSlice.actions;
export default notificationSlice.reducer;
